/*
 * Analytics Tracking — Bundle builder AJAX, widget interaction, CTA clicks
 * Extracted from theme.liquid inline scripts for deferred loading.
 * Depends on: dlPush(), shouldDedup(), KROWN.settings (all defined in theme.liquid <head>)
 */
(function() {
	if ( typeof dlPush !== 'function' ) return;

	// --- Bundle builder: AJAX intercept for success-based tracking ---
	function isBundleForm(form) {
		if ( form.closest('product-form[data-ajax-cart]') ) return false;
		if ( form.getAttribute('data-type') !== 'add-to-cart-form' ) return false;
		if ( !form.querySelector('input[name="properties[Box Size]"]') ) return false;
		return true;
	}

	function getBundleLocation(form) {
		var section = form.closest('[class*="section-"]');
		if ( section ) {
			var classes = section.className || "";
			if ( classes.indexOf('matcha') !== -1 ) return "bundle_builder_matcha";
		}
		var wrapper = form.closest('[class*="bundle-"]');
		if ( wrapper ) {
			var id = wrapper.className;
			var parentSection = form.closest('.shopify-section');
			if ( parentSection && parentSection.querySelector('[data-matcha-bundle]') ) return "bundle_builder_matcha";
		}
		return "bundle_builder";
	}

	function updateCartUI(text) {
		var cartAction = (typeof KROWN !== 'undefined' && KROWN.settings) ? KROWN.settings.cart_action : 'overlay';
		var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');

		if ( cartAction === 'popup' ) {
			if ( document.querySelector('[data-js-site-cart-popup-content]') ) {
				document.querySelector('[data-js-site-cart-popup-content]').innerHTML = sectionInnerHTML.querySelector('.shopify-section').innerHTML;
			}
		} else {
			var cartFormEl = sectionInnerHTML.getElementById('AjaxCartForm');
			var cartSubtotalEl = sectionInnerHTML.getElementById('AjaxCartSubtotal');
			if ( cartFormEl && document.getElementById('AjaxCartForm') ) {
				var cartItems = document.getElementById('AjaxCartForm');
				cartItems.innerHTML = cartFormEl.innerHTML;
				if ( typeof cartItems.ajaxifyCartItems === 'function' ) cartItems.ajaxifyCartItems();
			}
			if ( cartSubtotalEl && document.getElementById('AjaxCartSubtotal') ) {
				document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalEl.innerHTML;
			}
		}

		var countEl = sectionInnerHTML.querySelector('[data-cart-count]');
		var totalEl = sectionInnerHTML.querySelector('[data-cart-total]');
		if ( countEl ) {
			document.querySelectorAll('[data-header-cart-count]').forEach(function(elm) {
				elm.textContent = countEl.textContent;
			});
		}
		if ( totalEl ) {
			document.querySelectorAll('[data-header-cart-total]').forEach(function(elm) {
				elm.textContent = totalEl.textContent;
			});
		}

		var cartSidebar = document.getElementById('site-cart-sidebar');
		if ( cartSidebar && typeof cartSidebar.show === 'function' ) {
			cartSidebar.show();
		} else if ( cartSidebar ) {
			cartSidebar.setAttribute('aria-hidden', 'false');
			cartSidebar.style.display = '';
		}
	}

	document.addEventListener("submit", function(e) {
		var form = e.target;
		if ( !(form instanceof HTMLFormElement) ) return;
		if ( !form.action || form.action.indexOf("/cart/add") === -1 ) return;

		if ( isBundleForm(form) ) {
			e.preventDefault();

			var submitBtn = form.querySelector('button[type="submit"]');
			if ( submitBtn ) submitBtn.disabled = true;

			var cartAddUrl = (typeof KROWN !== 'undefined' && KROWN.settings && KROWN.settings.routes)
				? KROWN.settings.routes.cart_add_url + '.js'
				: '/cart/add.js';

			var formData = new FormData(form);
			var body = new URLSearchParams(formData).toString();

			fetch(cartAddUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'X-Requested-With': 'XMLHttpRequest'
				},
				body: body
			})
			.then(function(response) { return response.json(); })
			.then(function(data) {
				if ( data.status === 422 ) {
					var errorMsg = (typeof data.description === 'string') ? data.description : (data.message || 'Could not add to cart');
					var alertEl = document.createElement('span');
					alertEl.className = 'alert alert--error';
					alertEl.style.cssText = 'display:block;margin:1em 0;padding:10px 14px;background:#fce4e4;color:#c0392b;border-radius:6px;font-size:14px;';
					alertEl.textContent = errorMsg;
					var existing = form.querySelector('.alert--error');
					if ( existing ) existing.remove();
					form.prepend(alertEl);

					dlPush({
						event: "add_to_cart_error",
						error_status: 422,
						location: getBundleLocation(form),
						error_message: errorMsg
					});
					return;
				}

				try {
					var variantId = data.variant_id || data.id || form.querySelector('input[name="id"]')?.value;
					var quantity = Number(form.querySelector('input[name="quantity"]')?.value || 1);
					var currency = (window.Shopify?.currency?.active) || "GBP";
					var bundleLocation = getBundleLocation(form);
					var sellingPlan = form.querySelector('input[name="selling_plan"]')?.value || "";
					var purchaseType = form.querySelector('input[name="properties[Purchase Type]"]')?.value || "";
					var dedupKey = "atc_bundle_" + variantId + "_" + quantity + "_" + (sellingPlan || "onetime");

					if ( typeof shouldDedup === 'function' && !shouldDedup(dedupKey) ) {
						dlPush({
							event: "add_to_cart",
							source: "ajax_bundle",
							location: bundleLocation,
							purchase_type: purchaseType.toLowerCase().indexOf('subscri') !== -1 ? "sub" : "onetime",
							selling_plan: sellingPlan || undefined,
							ecommerce: {
								currency: currency,
								items: [{
									item_id: String(variantId),
									item_name: data.title || "",
									item_variant: String(variantId),
									price: Number(data.price) / 100,
									quantity: quantity
								}]
							}
						});
					}
				} catch (trackErr) {
					dlPush({ event: "add_to_cart_tracking_error", error_message: String(trackErr) });
				}

				var cartAction = (typeof KROWN !== 'undefined' && KROWN.settings) ? KROWN.settings.cart_action : 'overlay';
				if ( cartAction === 'no-overlay' ) {
					var cartUrl = (KROWN.settings.routes) ? KROWN.settings.routes.cart_url : '/cart';
					document.location.href = cartUrl;
					return;
				}

				var sectionUrl = (cartAction === 'popup')
					? (data.url || '/products/' + data.handle) + '?variant=' + (data.variant_id || '') + '&section_id=helper-cart-popup'
					: '?section_id=helper-cart';

				fetch(sectionUrl)
					.then(function(r) { return r.text(); })
					.then(function(text) { updateCartUI(text); });
			})
			.catch(function(err) {
				console.error('Bundle ATC error:', err);
				dlPush({ event: "add_to_cart_error", error_message: String(err), location: getBundleLocation(form) });
			})
			.finally(function() {
				if ( submitBtn ) submitBtn.disabled = false;
			});

			return;
		}

		if ( form.closest('product-form[data-ajax-cart]') ) return;

		var variantId = form.querySelector('input[name="id"]')?.value || "";
		var quantity = Number(form.querySelector('input[name="quantity"]')?.value || 1);
		var currency = (window.Shopify?.currency?.active) || "GBP";

		dlPush({
			event: "add_to_cart_intent",
			source: "post_form",
			location: "homepage_most_loved",
			ecommerce: {
				currency: currency,
				items: [{ item_id: String(variantId), item_variant: String(variantId), quantity: quantity }]
			}
		});
	}, true);

	// --- Ancient widget: subscribe vs one-time toggle ---
	document.addEventListener("click", function(e) {
		var optionRow = e.target.closest(".ancient-option-row");
		if ( optionRow && optionRow.closest(".ancient-purchase-widget[data-ancient-widget]") ) {
			setTimeout(function() {
				var widget = optionRow.closest(".ancient-purchase-widget[data-ancient-widget]");
				var active = widget.querySelector(".ancient-option-row.active")?.getAttribute("data-type") || "unknown";
				var sellingPlan = widget.querySelector('.ancient-option-row[data-type="sub"] input[name="selling_plan"]')?.value || "";
				var freqRadioActive = widget.querySelector(".ancient-freq-radio.active");
				var frequency =
					freqRadioActive?.getAttribute("data-freq-value") ||
					widget.querySelector("select[data-freq-dropdown]")?.value ||
					"";

				dlPush({
					event: "purchase_option_change",
					location: "pdp_widget",
					purchase_type: active,
					selling_plan: sellingPlan || undefined,
					frequency: frequency || undefined
				});
			}, 0);
		}

		var freqRadio = e.target.closest(".ancient-freq-radio");
		if ( freqRadio && freqRadio.closest(".ancient-purchase-widget[data-ancient-widget]") ) {
			var freq = freqRadio.getAttribute("data-freq-value") || "";
			dlPush({ event: "frequency_change", location: "pdp_widget", frequency: freq });
		}
	});

	// --- Ancient widget: frequency dropdown change ---
	document.addEventListener("change", function(e) {
		var dropdown = e.target.closest("select[data-freq-dropdown]");
		if ( dropdown && dropdown.closest(".ancient-purchase-widget[data-ancient-widget]") ) {
			dlPush({ event: "frequency_change", location: "pdp_widget", frequency: dropdown.value || "" });
		}
	});

	// --- CTA Click Tracking ---
	document.addEventListener('click', function(e) {
		var el = e.target.closest('[data-track="cta"]');
		if (!el) return;

		if (el.hasAttribute('data-track-interactive') && !e.target.closest('button, a, [role="button"], input[type="submit"]')) return;

		var cta = el.getAttribute('data-cta') || '';
		var payload = {
			event: 'cta_click',
			cta: cta,
			location: el.getAttribute('data-location') || ''
		};

		if (cta === 'pack_select') {
			var packSize = el.getAttribute('data-pack-size');
			var servings = el.getAttribute('data-servings');
			if (packSize) payload.pack_size = packSize;
			if (servings) payload.servings = servings;
			payload.cta_label = packSize + ' Pack' + (servings ? ' / ' + servings + ' Servings' : '');
		} else {
			var label = el.getAttribute('data-cta-label');
			if (!label) label = (el.textContent || '').replace(/\s+/g, ' ').trim();
			if (label) payload.cta_label = label;
		}

		dlPush(payload);
	});
})();
